import { render, staticRenderFns } from "./tabBeneficiary.vue?vue&type=template&id=17bb0a1c&"
import script from "./tabBeneficiary.vue?vue&type=script&lang=ts&"
export * from "./tabBeneficiary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports